<div class="container-lg w-auto">
  <div class="d-flex flex-column flex-lg-row links-row">
    <div class="col-12 col-lg" *ngFor="let column of datasourceService.s3Data.footer; let i = index">
      <div class="title mt-lg-0" [ngClass]="{ 'mt-5': i > 0 }">{{ column.label }}</div>
      <ng-container *ngFor="let link of column.links; let i = index">
        <a href="{{ link.link }}" target="_blank">{{ link.label }}</a>
      </ng-container>
    </div>
  </div>
  <div class="d-flex flex-column logo-row">
    <a [routerLink]="['/']" data-original-title="" title="" class="logo"
      ><img src="https://s3.eu-central-1.amazonaws.com/billcity.devels/webpage2.0/img/logo.png" alt="Billcity"
    /></a>
    <small>© 2017-{{ currentYear }} Taylorsoft Magyarország Kft.</small>
  </div>
</div>
